import { format, isValid } from 'date-fns';
import { type ReactElement } from 'react';
import { TimeElement } from '../../TimeElement/TimeElement';
import { capitalizeFirstLetter } from '../../Util';
import formatCloseRelative from '../../Util/formatCloseRelative';
import type { ClusteredMarkerLayerOptions } from '../Layers/Layers.types';
import { type ParkingGbgProperties } from '../Sources/ParkingsGbg/ParkingBase';
import PopupTemplateWrapper from './PopupTemplateWrapper';

export default function ParkingGbg(properties: ParkingGbgProperties, layerOptions: ClusteredMarkerLayerOptions): ReactElement {
    return (
        <PopupTemplateWrapper iconId={properties.iconId} title={layerOptions.name}>
            <div>
                <h3>{properties.name}</h3>
                <table>
                    <tbody>
                        {properties.freeSpaces !== null && (
                            <tr>
                                <td>Lediga platser:</td>
                                <td>{properties.freeSpaces}</td>
                            </tr>
                        )}
                        {properties.parkingSpaces != null && (
                            <tr>
                                <td>Antal platser:</td>
                                <td>{properties.parkingSpaces}</td>
                            </tr>
                        )}
                        {properties.maxParkingTime && (
                            <tr>
                                <td>Max parkeringstid:</td>
                                <td>
                                    {properties.maxParkingTime}
                                    {properties.maxParkingTimeLimitation && `. ${properties.maxParkingTimeLimitation}`}
                                </td>
                            </tr>
                        )}
                        {!!properties.parkableLength && (
                            <tr>
                                <td>Längd:</td>
                                <td>{properties.parkableLength} m</td>
                            </tr>
                        )}
                        {properties.parkingCharge && (
                            <tr>
                                <td>Taxa:</td>
                                <td>{properties.parkingCharge}</td>
                            </tr>
                        )}
                        {properties.residentialParkingArea && (
                            <tr>
                                <td>Boendeparkering:</td>
                                <td>{properties.residentialParkingArea}</td>
                            </tr>
                        )}
                        {properties.parkingCost && (
                            <tr>
                                <td>Avgift:</td>
                                <td>{properties.parkingCost}</td>
                            </tr>
                        )}
                        {properties.currentParkingCost && (
                            <tr>
                                <td>Jämförelseavgift (aktuell):</td>
                                <td>{properties.currentParkingCost} kr/tim</td>
                            </tr>
                        )}
                        {properties.phoneParkingCode && (
                            <tr>
                                <td>Telefonparkeringskod:</td>
                                <td>{properties.phoneParkingCode}</td>
                            </tr>
                        )}
                        {properties.extraInfo && (
                            <tr>
                                <td>Övrig information:</td>
                                <td>{properties.extraInfo}</td>
                            </tr>
                        )}
                        {properties.owner && (
                            <tr>
                                <td>Ägare:</td>
                                <td>{properties.owner}</td>
                            </tr>
                        )}
                    </tbody>
                </table>

                <div className="popup-details flex">
                    <dl>
                        {properties.updated != null && (
                            <>
                                <dt>Uppdaterad:</dt>
                                <dd title={properties.updated ? format(properties.updated, 'Pp') : ''}>
                                    {isValid(properties.updated) ? (
                                        <TimeElement date={properties.updated}>
                                            {capitalizeFirstLetter(formatCloseRelative(properties.updated))}
                                        </TimeElement>
                                    ) : (
                                        'Ingen uppgift'
                                    )}
                                </dd>
                            </>
                        )}
                        <dt>Källa:</dt>
                        <dd>{properties.provider}</dd>
                    </dl>
                </div>
            </div>
        </PopupTemplateWrapper>
    );
}
